import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import BackButton from '../misc/BackButton'
import appShowcaseBasic from '../../assets/illustrations/basic-onboarding.svg'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import LOG from "wipi-common/src/lib/logging/logger";
import InstallAppBanner from "../misc/InstallAppBanner";
import basicIlluDark from '../../assets/illustrations/basic-description-dark.svg'
import basicIlluLight from '../../assets/illustrations/basic-description-light.svg'

export default function StartBasicContinueInApp({isMobileDevice, caseId}) {

    useEffect(() => {
        LOG.logInfo(LOG_EVENTS.BA_APP_INFO)
    }, [])

    return <>
        <div className="row mb-5">
            <div className="col-lg-12">
                <InstallAppBanner caseId={caseId}
                                  isMobileDevice={isMobileDevice}
                                  showcaseImg={appShowcaseBasic}
                                  illustrationDark={basicIlluDark}
                                  illustrationLight={basicIlluLight}/>
            </div>
        </div>
        <BackButton isMobileDevice={isMobileDevice} to="/basic" iconOnly={true} />
    </>
}

StartBasicContinueInApp.propTypes = {
    isMobileDevice: PropTypes.bool.isRequired,
    caseId: PropTypes.string.isRequired
}
